module.exports = __webpack_public_path__ + "static/media/flower.54749087.png";